export default __webpack_public_path__ + "static/media/finance-logo-2-active.410a2e25.svg";